<template>
    <a
        :href="
            $page.props.language == 'fr'
                ? `${$page.props.appUrl}/emplois/${offer.slug}`
                : `${$page.props.appUrl}/job-opportunities/${offer.slug}`
        "
        class="group flex flex-col space-y-6 rounded-md border bg-gray-50 p-6 shadow"
        :class="[offer.promoted ? 'border-t-4 border-green-600 hover:border-t-4 hover:border-green-600' : '']"
        target="_blank"
        rel="noopener noreferrer"
    >
        <div>
            <a
                :href="
                    $page.props.locale == 'fr'
                        ? `${$page.props.appUrl}/emplois/${offer.slug}`
                        : `${$page.props.appUrl}/job-opportunities/${offer.slug}`
                "
                class="block text-2xl font-bold leading-tight hover:underline"
                target="_blank"
                rel="noopener noreferrer"
            >
                {{ offer.title }}
            </a>
            <a
                :href="`https://${offer.company?.subdomain}.camaq.ca`"
                class="font-semibold hover:underline"
                @click.stop
                target="_blank"
                rel="noopener noreferrer"
            >
                {{ offer.company?.name }}
            </a>
        </div>

        <div class="flex flex-col space-y-1 text-gray-600">
            <div v-if="offer.city && offer.city.length > 0" class="flex items-center space-x-2">
                <IconMapPin :size="16" class="text-gray-500" />
                <span class="font-medium">{{ offer.city }}</span>
            </div>

            <div v-if="offer.availability" class="flex items-center space-x-2">
                <IconClock24 :size="16" class="text-gray-500" />
                <span class="font-medium">{{ offer.availability }}</span>
            </div>
        </div>

        <div class="flex flex-1 items-end justify-center">
            <img loading="lazy" :src="offer.company?.logo" alt="" class="hidden h-32 w-64 object-contain md:block" />
        </div>
    </a>
</template>

<script setup>
    import { IconClock24, IconMapPin } from '@tabler/icons-vue';

    const props = defineProps({
        offer: Object,
    });
</script>
